import API from '../util/api';
import { store } from '../redux/store'
import { getToken, deleteToken } from 'firebase/messaging';
import { messaging } from '../util/firebase';

const token = store.getState().auth.authToken;
const VAPID_KEY = "BPloMmUNxdwyjeiIb-RZG7QzsRZ3oyfe21SqfvZ0p2NPkN-LOEVS6-vI_8aAIzzBiwdgyug7rktK0sd9NuoRXeE"; // Add your Firebase VAPID key here

// Get all Notifications
// export const getNotifications = async () => {
//     const { data } = await API.get("/api/notifications", {
//         headers: {
//             Authorization: `Bearer ${token}`
//         }
//     });

//     return data;
// };

export const getNotifications = async (token) => {
    try {

        let headers = {};
        headers.Authorization = `Bearer ${token}`
        const response = await API.get(`/api/notifications`, { headers: headers });
        if (response.status == 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

export const clearNotifications = async (token) => {
    const { data } = await API.patch("/api/notifications", {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return data;
}

export const getEAppsCredentials = async (token1) => {
    try {

        let headers = {};
        headers.Authorization = `Bearer ${token1}`;
        const response = await API.get(
            `/api/get_eapps_credentials`,
            {
                headers: headers,
            }
        );
        if (response.status === 200) {
            return response.data;
        }
    } catch (errors) {
        throw errors;
    }
};


export const subscribedUsers = async (token1) => {
    try {
        const response = await API.get(`/api/subscribed_user`, {
            headers: {
                Authorization: `Bearer ${token1}`
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (errors) {
        throw errors;
    }
};

/**
 * Generate and register FCM token if changed
 * Call this whenever you need to ensure token is up-to-date
 */
export async function ensureFcmToken(token) {
    try {
        // Get current token - SDK handles refresh implicitly
        const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (!currentToken) return false;

        // Compare with locally stored token
        const storedToken = localStorage.getItem('fcmToken');

        if (!storedToken || currentToken !== storedToken) {
            // Token has changed or is new - update server
            await API.post("/api/store_device_token",
                { deviceToken: currentToken },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            localStorage.setItem('fcmToken', currentToken);
        }

        return true;
    } catch (err) {
        if (err.code === 'messaging/token-unsubscribe-failed') {
            // Token invalid - clear storage and retry
            localStorage.removeItem('fcmToken');
            return ensureFcmToken(token);
        }
        return false;
    }
}

/**
 * Request notification permission and register token
 * Call during login or when explicitly requesting
 */
export async function requestNotificationPermission(token) {
    if (!("Notification" in window))
        return false;

    let permission = Notification.permission !== "granted"
        ? await Notification.requestPermission()
        : "granted";

    if (permission === "granted") {
        return await ensureFcmToken(token);
    }

    return false;
}

/**
 * Unregister FCM token
 * Call on logout
 */
export async function unregisterFcmToken(authToken) {
    try {
        // Delete from Firebase
        await deleteToken(messaging);

        // Delete from Laravel
        await API.post("/api/delete_device_token", {}, {
            headers: { Authorization: `Bearer ${authToken}` }
        });

        localStorage.removeItem('fcmToken');
        return true;
    } catch (err) {
        return false;
    }
}